"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.on = on;
/**
 * Выполняет подписку на событие целевого объекта.
 * @param target Целевой объект.
 * @param eventNames Имена событий через пробел.
 * @param callback Функция обратного вызова.
 * @param options Опции подписки.
 * @return Функция отписки.
 */
function on(target, eventNames, callback, options) {
    const eventNamesList = eventNames.split(' ');
    // обернуто чтобы прокинуть T
    // eslint-disable-next-line jsdoc/require-jsdoc
    const wrapped = (e) => callback(e);
    eventNamesList.forEach(eventName => {
        target.addEventListener(eventName, wrapped, options);
    });
    return () => {
        eventNamesList.forEach(eventName => {
            target.removeEventListener(eventName, wrapped, options);
        });
    };
}
//# sourceMappingURL=on.js.map